import { render, staticRenderFns } from "./GuiasDas.vue?vue&type=template&id=3c1f65e7&"
import script from "./GuiasDas.vue?vue&type=script&lang=js&"
export * from "./GuiasDas.vue?vue&type=script&lang=js&"
import style0 from "./GuiasDas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports